// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

.projects-container {
  background-color: gainsboro;
}

.create-project, .create-task {
  display:flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
}

#create-project-button, #create-task-button {
  margin-top: 10px;
}

.projects {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  width: auto;
  height: 100px;
}

.tasks {
  display:flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  gap: 20px;
  flex-wrap: wrap;
}

.task-card {
  display:flex;
  flex-direction: column;
  border: 2px solid gray;
  border-radius: 10px;
  width: 400px;
  padding: 5px 10px 10px;
}

.delete-button {
  flex-grow: 0;
  align-self: flex-end;
}`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB","sourcesContent":["* {\n  box-sizing: border-box;\n}\n\n.projects-container {\n  background-color: gainsboro;\n}\n\n.create-project, .create-task {\n  display:flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n}\n\n#create-project-button, #create-task-button {\n  margin-top: 10px;\n}\n\n.projects {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n  width: auto;\n  height: 100px;\n}\n\n.tasks {\n  display:flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 20px;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n\n.task-card {\n  display:flex;\n  flex-direction: column;\n  border: 2px solid gray;\n  border-radius: 10px;\n  width: 400px;\n  padding: 5px 10px 10px;\n}\n\n.delete-button {\n  flex-grow: 0;\n  align-self: flex-end;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
